import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Icon, Typography} from "@material-ui/core";
import {FuseAnimate, FusePageCarded} from '@fuse';
import {Link, withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import ReduxCalender from "../../../../store/actionreducers/calender";

class CalendarDateApp extends Component {

    state = {
        date: '',
    };

    async componentDidMount() {
        try {
            const date = this.props.match.params.date;
            this.setState({date})
            await this.props.getDateWorkEvents({date:date});
        } catch (e) {
            console.warn('you got an getDateWorkEvents error = ', e);
        }
    }

    render() {
        const {workEvents, lmWorkEvents, fmWorkEvents} = this.props;

        if (this.state.date.length === 0)
            return (<div/>)
        else
            return (
                <FusePageCarded
                    innerScroll
                    header={
                        <div className="flex flex-1 p-32 items-center justify-between">
                            <div className="flex flex-col items-start max-w-full">
                                <div className="flex items-center max-w-full">
                                    <div className="flex flex-col min-w-0">
                                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                            <div>
                                                <Typography className="text-24 truncate">
                                                    {this.state.date} 排班表
                                                </Typography>
                                            </div>
                                        </FuseAnimate>
                                    </div>
                                </div>
                            </div>
                            <Typography className="normal-case flex text-24 items-center" component={Link}
                                        role="button" to="/apps/calendar">
                                <Icon className="mr-4 text-24">arrow_back</Icon>
                                回到 醫師排班
                            </Typography>
                        </div>
                    }
                    content={
                        <div className="flex flex-1  justify-start p-28">
                            <div className="flex flex-1 flex-col">
                                <Typography className="text-24 truncate font-600 mt-12 mb-12 text-teal-darker">
                                    一線 排班醫師：
                                </Typography>
                                {
                                    workEvents.length > 0 ? workEvents.map((we, index, array) => {
                                        if(index === 0 || array[index].timePeriodId > array[index-1].timePeriodId){
                                            return(
                                                <Typography key={`${this.state.date}-we-${index}`} className="text-18 truncate font-500 mt-16">
                                                    {`${we.name}  ${we.start} - ${we.end} ${we.timerPeriod} `}
                                                </Typography>
                                            )
                                        } else {
                                            return(
                                                <Typography key={`${this.state.date}-we-${index}`} className="text-18 truncate font-500">
                                                    {`${we.name}  ${we.start} - ${we.end} ${we.timerPeriod} `}
                                                </Typography>
                                            )
                                        }

                                    }): <Typography className="text-18 truncate font-500">無</Typography>
                                }
                            </div>
                            <div className="flex flex-1 flex-col">
                                <Typography className="text-24 truncate font-600 mt-12 mb-12 text-blue-dark">
                                    二線 總值醫師：
                                </Typography>
                                {
                                    lmWorkEvents.length > 0 ? lmWorkEvents.map((we, index) => (
                                        <Typography key={`${this.state.date}-lm-${index}`} className="text-18 truncate font-500">
                                            {`${we.name}  全天 `}
                                        </Typography>
                                    )): <Typography className="text-18 truncate font-500">無</Typography>
                                }
                            </div>
                            <div className="flex flex-1 flex-col">
                                <Typography className="text-24 truncate font-600 mt-12 mb-12 text-pink-dark">
                                    三線 救火醫師：
                                </Typography>
                                {
                                    fmWorkEvents.length > 0 ? fmWorkEvents.map((we, index) => (
                                        <Typography key={`${this.state.date}-fm-${index}`} className="text-18 truncate font-500">
                                            {`${we.name}  全天 `}
                                        </Typography>
                                    )): <Typography className="text-18 truncate font-500">無</Typography>
                                }
                            </div>
                        </div>
                    }
                />
            )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDateWorkEvents: ReduxCalender.ActionCreator.getDateWorkEvents,
    }, dispatch);
}

function mapStateToProps({calendarApp}) {
    return {
        workEvents: calendarApp.new_date_events,
        lmWorkEvents: calendarApp.new_date_lm_events,
        fmWorkEvents: calendarApp.new_date_fm_events,
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CalendarDateApp));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/calendar/CalendarDateApp.js